import React from "react";
import Index from "./index";
import OurClientTable from "./OurClientTable";

const OurClients = () => {
    const { allOurClients, loading, history, search, setSearch, onDelete } = Index();
    return (
        <OurClientTable
            heading="All Our Clients"
            allOurClients={allOurClients}
            loading={loading}
            history={history}
            search={search}
            setSearch={setSearch}
            onDelete={onDelete}
        />
    );
};

const comparisonFn = function (prevProps, nextProps) {
    return prevProps.location.pathname === nextProps.location.pathname && prevProps.colorMode === nextProps.colorMode;
};
export default React.memo(OurClients, comparisonFn);
